var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00013 16C12.4113 16 16 12.4112 16 7.99996C16 3.58883 12.4113 0 8.00013 0C3.589 0 0.000244141 3.58883 0.000244141 7.99996C0.000244141 12.4112 3.589 16 8.00013 16ZM8.00013 1.09514C11.8074 1.09514 14.9048 4.19262 14.9049 7.99996C14.9049 11.8073 11.8075 14.9048 8.00013 14.9049C4.19286 14.9048 1.09545 11.8073 1.09545 7.99989C1.09545 4.19269 4.19286 1.09514 8.00013 1.09514Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9257 11.4264C7.13954 11.6402 7.48626 11.6401 7.70003 11.4264C7.91395 11.2125 7.91395 10.8658 7.69996 10.6519L5.59584 8.54788L11.689 8.5473C11.9914 8.54723 12.2364 8.30213 12.2364 7.99958C12.2364 7.69718 11.9913 7.45216 11.6889 7.45216L5.59554 7.45275L7.70018 5.34826C7.91402 5.13442 7.91402 4.78762 7.70018 4.57385C7.59322 4.46697 7.45311 4.41345 7.31294 4.41345C7.17283 4.41345 7.03273 4.46697 6.92577 4.57378L3.88648 7.613C3.78375 7.71565 3.72607 7.85488 3.72607 8.00017C3.72615 8.14546 3.78382 8.28461 3.88655 8.38748L6.9257 11.4264Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back-icon.737a82102380b30b41fa9c7d97ef662e.svg";
export { ForwardRef as ReactComponent };